/** Экран ждёт снимок: одна заглушка на все разделы. */
export const ScreenLoading = () => <div className="p-6 text-ink-muted">Loading…</div>;
